/**
 * Shared Firebase Configuration
 */
export const firebaseConfig = {
    apiKey: 'AIzaSyBBvRdpfGSNf4lPwl11rRIELPcfAUfrQFk',
    authDomain: 'summer2023-de48b.firebaseapp.com',
    databaseURL: 'https://summer2023-de48b-default-rtdb.firebaseio.com',
    projectId: 'summer2023-de48b',
    storageBucket: 'summer2023-de48b.appspot.com',
    messagingSenderId: '139376986932',
    appId: '1:139376986932:web:6d3e25523d644acb0f7361',
    measurementId: 'G-4GLRWQYS39',
};
